//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formCreate from '@form-create/element-ui';
import request from '@/api/request';
export default {
  name: 'RightDrawer',
  components: {
    formCreate: formCreate.$form()
  },
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      drawer: false,
      direction: 'rtl',
      rules: [],
      option: {
        form: {
          labelWidth: '125px',
          labelSuffix: '：'
        },
        submitBtn: false,
        global: {
          upload: {
            props: {
              onSuccess: function onSuccess(res, file) {
                if (res.status === 200) {
                  file.url = res.data.src;
                } else {
                  this.$Message.error(res.msg);
                }
              }
            }
          },
          frame: {
            props: {
              closeBtn: false,
              okBtn: false,
              onLoad: function onLoad(e) {
                e.fApi = _this.$refs.fc.$f;
              }
            }
          }
        }
      },
      FromData: null
    };
  },
  mounted: function mounted() {},
  methods: {
    handelOpen: function handelOpen() {
      this.drawer = true;
      this.getFormApi();
    },
    handleClose: function handleClose(done) {
      done();
    },
    getFormApi: function getFormApi() {
      var _this2 = this;
      var data = {};
      if (this.config.type == 1) {
        data.entid = 1;
      }
      request[this.config.method || 'get'](this.config.api, data).then(function (res) {
        _this2.FromData = res.data;
        _this2.rules = res.data.rule;
      }).catch(function (err) {
        _this2.$message.error(err.message || '获取失败');
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      this.$refs.fc.$f.submit(function (formData) {
        request[_this3.FromData.method.toLowerCase()](_this3.FromData.action.slice(7), formData).then(function () {
          _this3.$store.dispatch('user/getMenus');
          _this3.$emit('changge');
          _this3.drawer = false;
        });
      });
    }
  }
};